import { isDocSite, navbarModuleNavigator } from '@/utils'
import Header from '@/components/Header'
import React, { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '../Auth'
import FloatNav from '../FloatNav'

const isAppView = (path: string) => {
  return path.includes('app')
}

const Navbar: React.FC<unknown> = () => {
  const { authInfo } = useContext(AuthContext)
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    if (pathname === '/' && authInfo.auth && !isDocSite) {
      navigate('/console/workbench')
    }
  }, [authInfo, pathname])

  return <>{isAppView(location.pathname) ? <FloatNav /> : <Header />}</>
}

export default Navbar
